// Parse a comma-separated CMS string of numbers into a numeric array.
// Empty/invalid entries are filtered out. Falls back to provided defaults.
// Used so admins can edit price preset tiers from CMS Fiyatlar tab.
export function parsePresetList(raw, fallback = []) {
  if (!raw) return fallback;
  const parts = String(raw)
    .split(",")
    .map((s) => parseFloat(String(s).trim()))
    .filter((n) => Number.isFinite(n) && n > 0);
  return parts.length > 0 ? parts : fallback;
}

export function parsePrice(raw, fallback) {
  const n = parseFloat(raw);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}
